import { GroupBookingFormConfig } from './GroupBookingFormConfig';

export { GroupBookingFormConfig };
